var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"credit-view"},[_c('HeaderView',{attrs:{"title":"累積紅利","isLeft":true}}),_c('div',{staticClass:"card-bonus-img"},[_c('van-image',{attrs:{"src":"https://m.s383.com/site/img/m383_card_bonus.jpg","width":"100%","lazy-load":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }